import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import { getCsnId, phoneFormattedWithMDash, firstNameFirst } from "../../helpers/formatting";
import GenericInput from "../common/input/GenericInput";
import EmailOrPhoneNumber from "../common/input/EmailOrPhoneNumber";
import MiniSpinner from "../common/MiniSpinner";

class GuestLinkBody extends React.Component {
    constructor(props) {
        super(props);
        const { guestName, emailOrNumber } = props;
        const number = emailOrNumber && emailOrNumber.indexOf('@') === -1 && phoneFormattedWithMDash(emailOrNumber);
        this.state = {
            guestName: guestName || '', emailOrNumber: number || emailOrNumber || '', isEmailOrNumberValid: false, showEmailOrNumberMessage: '',
            number: '', email: '', isMobileNumberValid: false, isEmailValid: false, currentTime: '', showSmsMessage: true, showEmailMessage: true
        };
    }

    componentDidMount() {
        this.smsSent = this.emailSent = false;
        logUI("UI.ShareVideoVisitModalForGuest.Body.ComponentDidMount", new Date(), Tools.getURLPath(), null, this.props.csnId);
    }

    notifySuccess = () => {
        if (this.props.onLinkSent) {
            this.props.onLinkSent(`Link sent to ${this.state.emailOrNumber} at ${this.state.currentTime}`, true);
        }
    };

    notifyFailure = () => {
        if (this.props.onLinkSent) {
            this.props.onLinkSent(`Link failed to ${this.state.emailOrNumber} at ${this.state.currentTime}`, false);
        }
    };

    emailOrSmsVideoVisitLink = () => {
        const { isMobileNumberValid, isEmailValid, emailOrNumber, guestName } = this.state;
        if (isMobileNumberValid || isEmailValid) {
            const currentTime = Tools.dateStringFormat(new Date(), "h:mm A")
            const roomId = getCsnId(this.props.location.pathname);
            if (isMobileNumberValid) {
                this.setState({ currentTime, showSmsMessage: true, showEmailMessage: false, smsSent: true, emailSent: false })
                logUI("UI.ShareVideoVisitModalForGuest.SMS", new Date(), Tools.getURLPath(), { guestName, phone: emailOrNumber }, this.props.csnId);
                this.props.sendSms(roomId, guestName, emailOrNumber, this.props.participantRole, () => {
                    this.props.getShareLinkHistory(roomId);
                    if (this.props.smsVideoVisitLinkForGuest.isSuccess) {
                        this.notifySuccess();
                    }
                    else {
                        this.notifyFailure();
                    }
                    this.closeModal();
                });
            }
            else if (isEmailValid) {
                this.setState({ currentTime, showEmailMessage: true, showSmsMessage: false, emailSent: true, smsSent: false })
                logUI("UI.ShareVideoVisitModalForGuest.Email", new Date(), Tools.getURLPath(), { guestName, email: emailOrNumber }, this.props.csnId);
                this.props.sendEmail(roomId, guestName, emailOrNumber, this.props.participantRole, () => {
                    this.props.getShareLinkHistory(roomId);
                    if (this.props.emailVideoVisitLinkForGuest.isSuccess) {
                        this.notifySuccess();
                    }
                    else {
                        this.notifyFailure();
                    }
                    this.closeModal();
                });
            }
        }
        else
            return;
    }

    closeModal = () => {
        if (this.props.closeModal) {
            this.props.closeModal();
        }
    }

    render() {
        const { guestName, emailOrNumber, smsSent, emailSent, isMobileNumberValid, isEmailValid, currentTime, showEmailMessage, showSmsMessage } = this.state;
        const { smsVideoVisitLinkForGuest, emailVideoVisitLinkForGuest, participantRole, csnIdOfAppointment } = this.props;
        let disabled = (((isEmailValid || isMobileNumberValid) === undefined) || (isEmailValid || isMobileNumberValid) === false) ? true : (isEmailValid || isMobileNumberValid) ? false : false;
        disabled = (smsVideoVisitLinkForGuest !== undefined && (smsVideoVisitLinkForGuest && smsVideoVisitLinkForGuest.isWaiting)) || (emailVideoVisitLinkForGuest !== undefined && (emailVideoVisitLinkForGuest && emailVideoVisitLinkForGuest.isWaiting)) ? true : disabled;
        const patientAppt = this.props.providerAppointments && csnIdOfAppointment ? this.props.providerAppointments.find(visit => visit.csnId === csnIdOfAppointment) : null;
        const patientInRoom = patientAppt && patientAppt.patientInRoom;

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-12">
                        <div className="add-guest-popover__section">
                            <div className="row no-gutters shared-link-group">
                                <div className="col-12">
                                    {participantRole && participantRole.toLowerCase() === "patient"
                                        ? <div className={"shared-link-group__user details-icon-prepend" + (patientInRoom ? " user-in-room" : "")}>
                                            <div className="icon-col"><span className="icon-user" /></div>
                                            <div className="details-col">
                                                {guestName}
                                            </div>
                                        </div>
                                        : <GenericInput placeholder="Guest's Name (Optional)"
                                            value={guestName} name="guestName" showClearBtn autofocus
                                            onChange={(e, value) => this.setState({ guestName: value })}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="add-guest-popover__divider">
                            <div className="row no-gutters shared-link-group">
                                <div className="col-12">
                                    <hr className="hr-divider" />
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="add-guest-popover__section">
                            <div className="row no-gutters shared-link-group">
                                <div className="col-12">
                                    <EmailOrPhoneNumber placeholder="Mobile Number or Email" value={emailOrNumber} name="emailOrNumber" showClearBtn validateOnMount required={false} 
                                        onChange={(value, { isValid, isValidEmail, isValidPhone }) =>
                                            this.setState({
                                                smsSent: false, emailSent: false, emailOrNumber: value, isEmailOrNumberValid: isValid,
                                                showEmailOrNumberMessage: false, isEmailValid: isValidEmail, isMobileNumberValid: isValidPhone
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="add-guest-popover__section">
                            <div className="row no-gutters shared-link-group">
                                <div className="col-12">
                                    <button type="button" className="btn text-btn" onClick={this.emailOrSmsVideoVisitLink}
                                        disabled={disabled}
                                    >SEND</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {smsSent && smsVideoVisitLinkForGuest &&
                    <div className="row">
                        <div className="col-12">
                            {showSmsMessage && smsVideoVisitLinkForGuest.isSuccess &&
                                <div className="success-msg">
                                    <span className="icon-list-check" />{" "}
                                                    Link sent to {emailOrNumber} at {currentTime}
                                </div>
                            }
                            {showSmsMessage && smsVideoVisitLinkForGuest.isFailure &&
                                <div className="error-msg">
                                    <span className="icon-input-clear" />{" "}
                                                    Link failed to {emailOrNumber} at {currentTime}
                                </div>
                            }
                        </div>
                    </div>
                }
                {emailSent && emailVideoVisitLinkForGuest &&
                    <div className="row">
                        <div className="col-12">
                            {showEmailMessage && emailVideoVisitLinkForGuest.isSuccess &&
                                <div className="success-msg">
                                    <span className="icon-list-check" />{" "}
                                                    Link sent to {emailOrNumber} at {currentTime}
                                </div>
                            }
                            {showEmailMessage && emailVideoVisitLinkForGuest && emailVideoVisitLinkForGuest.isFailure &&
                                <div className="error-msg">
                                    <span className="icon-input-clear" />{" "}
                                                    Link failed to {emailOrNumber} at {currentTime}
                                </div>
                            }
                        </div>
                    </div>
                }

                {((smsVideoVisitLinkForGuest && smsVideoVisitLinkForGuest.isWaiting) || (emailVideoVisitLinkForGuest && emailVideoVisitLinkForGuest.isWaiting)) &&
                    <div className="row overlay-loading-container">
                        <div className="col-12 align-self-center">
                            <MiniSpinner />
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        smsVideoVisitLinkForGuest: ownProps && ownProps.participantRole && ownProps.participantRole.toLowerCase() === 'patient' ? state.videoVisit.smsVideoVisitLink : state.videoVisit.smsVideoVisitLinkForGuest,
        emailVideoVisitLinkForGuest: ownProps && ownProps.participantRole && ownProps.participantRole.toLowerCase() === 'patient' ? state.videoVisit.emailVideoVisitLink : state.videoVisit.emailVideoVisitLinkForGuest,
        providerAppointments: state.epic.providerAppointments
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendSms: (room, participantName, mobileNumber, participantRole, callback) => {
            if (participantRole && participantRole.toLowerCase() === 'patient') {
                dispatch({ type: types.SMS_VIDEO_VISIT_LINK, room, mobileNumber, participantName, callback });
            }
            else {
                dispatch({ type: types.SMS_VIDEO_VISIT_LINK_FOR_GUEST, room, guestName: participantName, mobileNumber, callback });
            }
        },
        sendEmail: (room, participantName, email, participantRole, callback) => {
            if (participantRole && participantRole.toLowerCase() === 'patient') {
                dispatch({ type: types.EMAIL_VIDEO_VISIT_LINK, room, email, participantName, callback });
            }
            else {
                dispatch({ type: types.EMAIL_VIDEO_VISIT_LINK_FOR_GUEST, room, guestName: participantName, email, callback });
            }
        },
        getShareLinkHistory: (room) => dispatch({ type: types.VIDEO_VISIT_SHARE_LINK_HISTORY, room })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GuestLinkBody));